import { EmployeeProductivity } from 'components/employee-analytics/analytic-item/EmployeeProductivity'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { API_EMPLOYEE_ANALYTICS } from 'services/apiEmployeeAnalytics'
import { useFetch } from 'services/useFetch'
import { getYears } from 'utils/utils'

const INITIAL_FILTER = {
    year: moment().get('year'),
    company_ids: [],
    department_ids: [],
    division_ids: [],
    subdivision_ids: [],
}

const OFFSET = 102

const EmployeeProductivityContainer = () => {
    const { fetching: getEmployeeProductivityIndex, isLoading } = useFetch(API_EMPLOYEE_ANALYTICS.EMPLOYEE_PRODUCTIVITY)
    const [employeeProductivityData, setEmployeeProductivityData] = useState([])
    const [filter, setFilter] = useState(INITIAL_FILTER)

    useEffect(() => {
        ;(async () => {
            const employeeProductivity = await getEmployeeProductivityIndex(filter)
            const data = employeeProductivity?.data || []

            const salaries = data?.map((d) => d.total_salary ?? 0)
            const isAllZeroSalary = salaries?.every((s) => s === 0)
            const maxSalary = Math.max(...salaries)
            const minSalary = Math.min(...salaries)
            const safeMinSalary = isAllZeroSalary ? 0 : minSalary
            const safeMaxSalary = isAllZeroSalary ? 1_000_000 : maxSalary
            const range = safeMaxSalary - safeMinSalary || 1

            const newData = data?.map((item) => {
                const normalized = isAllZeroSalary ? 0 : (item.total_salary - safeMinSalary) / range

                return {
                    period: item?.raw_period,
                    kpi: item?.kpi_achievement,
                    total_salary: item?.total_salary,
                    total_salary_scaled: isAllZeroSalary ? OFFSET : normalized * 100 + OFFSET,
                }
            })

            setEmployeeProductivityData(newData)
        })()
    }, [filter])

    const styleBar = (key) => {
        switch (key) {
            case 'kpi':
                return '#0f4c5c'
            case 'total_salary':
                return '#f4b400'
            default:
                return '#788192'
        }
    }

    const onSubmitFilter = (newFilter) => {
        if (JSON.stringify(filter) !== JSON.stringify(newFilter)) {
            setFilter(newFilter)
        }
    }

    const props = {
        data: employeeProductivityData,
        styleBar,
        isLoading,
        filter,
        onSubmitFilter,
        years: getYears(2021),
    }

    return <EmployeeProductivity {...props} />
}

export default EmployeeProductivityContainer
